// import { mock, fetch } from './fetch';
import { loadModules } from 'esri-loader';

const { 
    REACT_APP_BASE_URL_GIS_SERVER} = window['runConfig'];
    
export const getLengthByTypeDMA = (token, whereClause) => {

    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_PIPELINES_V1/MapServer/2/Query`;

            const bodyFormData_getLengthByTypeDMA = new FormData();
            bodyFormData_getLengthByTypeDMA.set('f', 'json');
            const outStatistics = [{
                "statisticType": "sum",
                "onStatisticField": "SHAPE.STLength()/1000",
                "outStatisticFieldName": "LenghtOfMaterial"
            }];
            bodyFormData_getLengthByTypeDMA.append('outStatistics', JSON.stringify(outStatistics));
            bodyFormData_getLengthByTypeDMA.append('groupByFieldsForStatistics', 'DMAID, TYPE, MATERIAL');
            bodyFormData_getLengthByTypeDMA.append('outFields', 'DMAID, TYPE, MATERIAL');
            bodyFormData_getLengthByTypeDMA.append('orderByFields', 'DMAID ASC, TYPE ASC, MATERIAL ASC');

            bodyFormData_getLengthByTypeDMA.append('token', `${token}`);

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_getLengthByTypeDMA,
            })

        });

    return res;
}